import { createFileRoute, redirect } from "@tanstack/react-router";

import LoginPage from "~/pages/auth/LoginPage";
import { HOME_PATH } from "~/routes/-route-constants/appRoutes.ts";

export const Route = createFileRoute("/login")({
    validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
        return {
            redirect: search.redirect as string,
        };
    },
    beforeLoad: ({ context, search }) => {
        if (context.auth.user) {
            throw redirect({ to: search.redirect || HOME_PATH });
        }
    },
    component: LoginPage,
});
